Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "EmptyStateView1470909390",
  {"root":"EmptyStateView1470909390--root","container":"EmptyStateView1470909390--container"},
  "",
  2,
  "EmptyStateView1470909390"
);

